import { orderInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { css } from "styled-components";

orderInformationStyles.orderNumberHeading = {
    variant: "h2",
    as: "h2",
    color: "primary",
    css: css`
        margin-bottom: 5px;
        background-color: #f3efeb;
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        font-family: "LibreBaskerville";
        font-weight: normal;
        width: 100%;
        border-radius: 4px;
        @media print {
            font-size: 24px !important;
        }
    `,
};

orderInformationStyles.headingAndTextStyles = {
    heading: {
        color: "text.main",
        fontFamily: "LatoBold",
        size: 15,
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 16px;
                font-weight: lighter;
                padding-left: 8px;
            }
            font-style: normal;
            text-transform: capitalize;
            margin-bottom: 5px;
        `,
    },
    text: {
        css: css`
            @media print {
                font-size: 16px;
                padding-left: 8px;
            }
        `,
    },
};

orderInformationStyles.orderDetailsGridContainer = {
    css: css`
        padding: 0rem 1.5rem;
        padding-bottom: 15px;
    `,
};

orderInformationStyles.orderConfirmationShippingInformation = {
    shippingAddressTitle: {
        color: "text.main",
        fontFamily: "LatoBold",
        size: 15,
        css: css`
            font-style: normal;
            @media print {
                font-size: 18px;
                width: 100vw;
                font-weight: lighter !important;
            }
        `,
    },
    shippingInformationTitle: {
        variant: "h2",
        as: "h2",
        color: "primary",
        css: css`
            margin-bottom: 5px;
            background-color: #f0f4f3;
            padding: 0.5rem 1rem;
            font-size: 1.25rem;
            font-family: "LibreBaskerville";
            font-weight: normal;
            width: 100%;
            border-radius: 4px;
            @media print {
                font-size: 24px !important;
                width: 100vw;
            }
        `,
    },
    shippingInformationAddressGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            flex-direction: column;
            padding-left: 1.5rem;
        `,
    },
    shippingInformationCarrierGridItem: {
        css: css`
            display: none;
            @media print {
                display: none !important;
            }
        `,
    },
    shippingInformationServiceGridItem: {
        css: css`
            display: none;
            @media print {
                display: none !important;
            }
        `,
    },
};

orderInformationStyles.orderConfirmationBillingInformation = {
    billingInformationTitle: {
        variant: "h2",
        as: "h2",
        color: "primary",
        css: css`
            margin-bottom: 5px;
            background-color: #f0f4f3;
            padding: 0.5rem 1rem;
            font-size: 1.25rem;
            font-family: "LibreBaskerville";
            font-weight: normal;
            width: 100%;
            border-radius: 4px;
            @media print {
                font-size: 24px !important;
                width: 100vw;
            }
        `,
    },
    billingInformationBillingAddressGridItem: {
        width: [12, 12, 4, 4, 4],
        printWidth: 4,
        css: css`
            flex-direction: column;
            padding-left: 1.5rem;
        `,
    },
    billingAddressTitle: {
        color: "text.main",
        fontFamily: "LatoBold",
        size: 15,
        css: css`
            font-style: normal;
            @media print {
                font-size: 18px;
                width: 100vw;
                font-weight: lighter !important;
            }
        `,
    },
    billingInformationCreditCardAddressGridItem: {
        css: css`
            display: none;
            @media print {
                display: none !important;
            }
        `,
    },
};
